import { render, staticRenderFns } from "./ServiceReqView.vue?vue&type=template&id=6e2fb491"
import script from "./ServiceReqView.vue?vue&type=script&lang=js"
export * from "./ServiceReqView.vue?vue&type=script&lang=js"
import style0 from "./ServiceReqView.vue?vue&type=style&index=0&id=6e2fb491&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports